import { render, staticRenderFns } from "./VesselInfoContent.vue?vue&type=template&id=f42936c4&scoped=true&"
import script from "./VesselInfoContent.vue?vue&type=script&lang=ts&"
export * from "./VesselInfoContent.vue?vue&type=script&lang=ts&"
import style0 from "./VesselInfoContent.vue?vue&type=style&index=0&id=f42936c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42936c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VCol,VIcon,VRow,VTooltip})
